export const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: "dashboard", testId: "nav-admin-dashboard" },  { to: "/admin/users", label: "Clientes", icon: "users", testId: "nav-admin-users" },
  { to: "/admin/invite-codes", label: "Códigos", icon: "codes", testId: "nav-admin-codes" },
  { to: "/admin/assets", label: "Ativos", icon: "assets", testId: "nav-admin-assets" },
  { to: "/admin/providers", label: "APIs", icon: "plug", testId: "nav-admin-providers" },
  { to: "/admin/payments", label: "Pagamentos", icon: "wallet", testId: "nav-admin-payments" },
  { to: "/admin/documents", label: "Documentos", icon: "codes", testId: "nav-admin-documents" },
  { to: "/admin/brands", label: "Brands", icon: "shield", testId: "nav-admin-brands" },
  { to: "/admin/settings", label: "Minha conta", icon: "shield", testId: "nav-admin-settings" },
  { to: "/admin/market-config", label: "Mercados", icon: "markets", testId: "nav-admin-markets" },
  { to: "/admin/team", label: "Equipa", icon: "shield", testId: "nav-admin-team" },
  { to: "/inbox", label: "Mensagens", icon: "chat", testId: "nav-admin-inbox" },
  { to: "/admin/sup-audit", label: "Auditoria", icon: "shield", testId: "nav-admin-sup-audit" },
  { to: "/admin/trading", label: "Trading", icon: "markets", testId: "nav-admin-trading" },
  { to: "/security", label: "Segurança", icon: "shield", testId: "nav-admin-security" },
];
